import { ColumnHeaderMultiSelectFilter } from "components/ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import { TaskTrackerTrackerFilterType } from "./SalesTaxTracker";
import { useMemo } from "react";
import { useGetCountriesDataQuery } from "store/apis/onboarding";
import { useGetAllInkleCPATeamsQuery } from "store/apis/internalTeamSetting";
import {
  ColumnFilterKey,
  DUE_FILINGS,
  filterKeyMap,
  FilterKeyName,
  PENDING_REGISTRATIONS,
  registrationTaskStatusOptions,
  SERVICE_TEAM_IDS,
  TASK_STATUS,
  taskStatusOptions,
  taskTypeOptions,
  UNASSIGNED_SERVICE_TEAM,
} from "./TaskTrackerOptions";
import { TASK_TYPE } from "store/apis/taskTrackerSalesTax";
import { useQuery } from "hooks/useQuery";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const SelectFilter = ({
  name,
  filter,
}: {
  name: FilterKeyName;
  filter: TaskTrackerTrackerFilterType;
}) => {
  const { values, updateFilter } = filter;
  const query = useQuery();
  const selectedTab = query.get("tab") || TASK_TYPE.FILINGS;
  const { isAdmin } = useRoleBasedView();
  const { data: countries } = useGetCountriesDataQuery();

  const unitatedStates = countries?.find(
    (country) => country.name === "United States"
  )?.states;

  const stateOptions = useMemo(() => {
    return (
      unitatedStates?.map((state) => ({
        label: state.name,
        value: state.uuid,
      })) || []
    );
  }, [unitatedStates]);

  const { data: teamData = [] } = useGetAllInkleCPATeamsQuery(
    { accessibleTeams: "CPA_TEAM" },
    { skip: !isAdmin }
  );

  const teamOptions = teamData.map((team) => ({
    value: team.uuid,
    label: team.name,
  }));

  const filterKey = filterKeyMap[name] as ColumnFilterKey;

  const optionMap = {
    PAYMENT_SCHEDULE: taskTypeOptions,
    STATE: stateOptions,
    TASK_STATUS:
      selectedTab === TASK_TYPE.FILINGS
        ? taskStatusOptions
        : registrationTaskStatusOptions,
    SERVICE_TEAM_IDS: teamOptions,
  };

  const handleFilterUpdate = (name: string, value: string | null) => {
    updateFilter(filterKey, value || "");
    if (name === TASK_STATUS) {
      updateFilter(DUE_FILINGS, false);
      updateFilter(PENDING_REGISTRATIONS, false);
    }

    if (name === UNASSIGNED_SERVICE_TEAM) {
      updateFilter(SERVICE_TEAM_IDS, "");
    }
  };

  return (
    <div className="t-flex t-items-center t-gap-x-4 t-justify-between t-w-full t-flex-nowrap">
      <div className="t-text-nowrap">{name}</div>
      <ColumnHeaderMultiSelectFilter
        filterName={filterKey}
        options={optionMap[filterKey] || []}
        selected={
          typeof values[filterKey] === "string" ? values[filterKey] : null
        }
        updateFilter={handleFilterUpdate}
        className="t-w-72"
      />
    </div>
  );
};
